import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import {
  Row,
  Col,
} from 'reactstrap';
import AudioProgressiveBar from './AudioProgressiveBar'
import useAudio3 from "./useAudio3"

// AudioController
const AudioController = forwardRef((props, ref) => {

  // audio
  let [
    play,
    pause,
    setCurrentTime,
    currentTime,
    playing,
    played,
    duration,
  ] = useAudio3(props.mediaUrl);

  // let [abc, setAbc] = useState(0)

  // wait a second
  let _wait = ({ msec }) => {
    return new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve()
      }, msec);
    })
  }

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({

    getDuration() {
      return duration
    },

    pauseAudio() {
      pause()
    },

    playAudio() {
      play()
    },

    setAudioTimestamp(_time) {
      setCurrentTime(_time)
    },

  }));

  // componentDidMount
  useEffect(() => {

    // console.log("aaa props.setPlayerCurrentTime")
    props.setPlayerCurrentTime(currentTime)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime]);

  // componentDidMount
  useEffect(() => {

    if (playing === false) {
      props.pauseMedia()
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [played, playing]);


  // componentDidMount
  useEffect(() => {

    return () => {
      console.log("cleanup")
      pause()
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // play audio
  let _togglePlayAudio = () => {

    if (playing === true) {
      // props.setIsPlaying(false)
      props.pauseMedia()
      pause()
    } else {

      // props.setIsPlaying(true)
      props.playMedia()
      play()
    }
  }

  // set current time from slider
  let _updateCurrentPercent = (percent) => {

    if (isNaN(duration) === true) {
      return
    }
    if (isFinite(percent) === false) {
      return
    }

    setCurrentTime(duration * percent * 0.01)
  }

  return (
    <div style={{
      // marginRight: 120,
      // marginLeft: 120,
    }}>

      {/* audio div */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
        paddingLeft: 120,
        paddingRight: 120,
      }}>

        <Col md="12" xs="12" style={{
          textAlign: 'left',
        }}>

          {/* audio progress bar */}
          <AudioProgressiveBar
            updateCurrentPercent={_updateCurrentPercent}
            playing={playing}
            played={played}
            togglePlayAudio={_togglePlayAudio}
            duration={duration}
            currentTime={currentTime} />

        </Col>
      </Row>
    </div>
  )
})

export default AudioController
